import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { NAV_LINKS } from "./content";
import { scrollToId } from "./utils";

export const HireNav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <header
            data-testid="hire-nav"
            className={cn(
                "fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300",
                scrolled || open
                    ? "bg-white/85 backdrop-blur-xl border-b border-hire-line shadow-[0_1px_0_rgba(0,0,0,0.02)]"
                    : "bg-transparent border-b border-transparent"
            )}
        >
            <nav className="container-page h-16 md:h-[72px] flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="hire-nav-logo"
                    aria-label="AV Consultation home"
                    className="flex items-center gap-2.5 text-hire-ink font-bold tracking-tight text-[17px]"
                >
                    <span className="h-7 w-7 rounded-lg bg-brand-blue text-white grid place-items-center text-xs font-extrabold">
                        AV
                    </span>
                    AV Consultation
                </Link>

                <div className="hidden md:flex items-center gap-1">
                    {NAV_LINKS.map((l) => (
                        <button
                            key={l.id}
                            type="button"
                            data-testid={`hire-nav-${l.id}`}
                            onClick={() => go(l.id)}
                            className="h-9 px-3.5 rounded-lg text-sm font-medium text-hire-muted hover:text-hire-ink hover:bg-hire-bg transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        type="button"
                        data-testid="hire-nav-cta"
                        onClick={() => go("hire-form")}
                        className="ml-3 h-10 px-5 rounded-xl bg-brand-blue text-white text-sm font-semibold hover:bg-brand-blue-dark transition-colors shadow-[0_6px_18px_-8px_rgba(45,91,255,0.6)]"
                    >
                        Hire Talent
                    </button>
                </div>

                <button
                    type="button"
                    aria-label={open ? "Close menu" : "Open menu"}
                    aria-expanded={open}
                    data-testid="hire-nav-menu-toggle"
                    onClick={() => setOpen((o) => !o)}
                    className="md:hidden h-10 w-10 grid place-items-center rounded-lg border border-hire-line text-hire-ink"
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="hire-nav-mobile-menu"
                    className="md:hidden border-t border-hire-line bg-white px-6 pb-6 pt-3 flex flex-col gap-1"
                >
                    {NAV_LINKS.map((l) => (
                        <button
                            key={l.id}
                            type="button"
                            data-testid={`hire-nav-mobile-${l.id}`}
                            onClick={() => go(l.id)}
                            className="h-12 text-left px-2 rounded-lg text-[15px] font-medium text-hire-ink hover:bg-hire-bg"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        type="button"
                        data-testid="hire-nav-mobile-cta"
                        onClick={() => go("hire-form")}
                        className="mt-2 h-12 rounded-xl bg-brand-blue text-white text-[15px] font-semibold"
                    >
                        Hire Talent
                    </button>
                </div>
            )}
        </header>
    );
};

export default HireNav;
